export default "__VITE_ASSET__BlLDpnfw__"